import { render, staticRenderFns } from "./VersionSpreadDonut.vue?vue&type=template&id=141a845e&"
import script from "./VersionSpreadDonut.vue?vue&type=script&lang=js&"
export * from "./VersionSpreadDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports